import { render } from "./OnBoard.vue?vue&type=template&id=8e928a6a"
import script from "./OnBoard.vue?vue&type=script&lang=js"
export * from "./OnBoard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__